import React, { FC, useEffect } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import InfiniteScroll from 'react-infinite-scroll-component';

import { generatePath, Link } from 'react-router-dom';

import useStyles from './styles';
import { useGetDiscussions } from '../../hooks/queries/useGetDiscussions';
import DiscussionItem from '../DiscussionsList/DiscussionItem';
import DiscussionUserEmpty from '../DiscussionsList/DiscussionUserEmpty';
import { useSubscription } from '@apollo/react-hooks';
import { LISTEN_TO_GLOBAL_NEW_MESSAGE } from '../../graphql/discussion/subscription';
import { GlobalNewMessageToDiscussion } from '../../graphql/discussion/types/GlobalNewMessageToDiscussion';

export const PAGE_SIZE = 10;

interface IDiscussionsList {
  discussionId?: number;
}

const ListDiscussions: FC<IDiscussionsList> = (props) => {
  const { discussionId } = props;
  const classes = useStyles();

  const [getDiscussions, { data, loading, fetchMore }] = useGetDiscussions();
  useEffect(() => {
    getDiscussions({
      variables: {
        input: { skip: 0, take: PAGE_SIZE },
      },
    });
  }, [getDiscussions]);
  const handleNext = () => {
    fetchMore({
      variables: {
        input: {
          take: PAGE_SIZE,
          skip: data?.discussions?.discussions?.length ?? 0,
        },
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if ((fetchMoreResult?.discussions?.discussions?.length ?? 0) === 0) {
          return prev;
        }
        return Object.assign({}, prev, {
          discussions: {
            __typename: prev?.discussions?.__typename ?? '',
            discussions: [
              ...(prev?.discussions?.discussions ?? []),
              ...(fetchMoreResult?.discussions?.discussions ?? []),
            ],
            totalCount: fetchMoreResult?.discussions?.totalCount ?? 0,
          },
        });
      },
    });
  };
  //subscription
  useSubscription<GlobalNewMessageToDiscussion>(LISTEN_TO_GLOBAL_NEW_MESSAGE, {
    onSubscriptionData({ client, subscriptionData }) {
      getDiscussions({
        variables: {
          input: { skip: 0, take: PAGE_SIZE },
        },
      });
    },
  });
  if (!data?.discussions?.discussions?.length && loading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexGrow={1}>
        <CircularProgress />
      </Box>
    );

  if (!data?.discussions?.totalCount) return <DiscussionUserEmpty />;

  const Label: FC = ({ children }) => (
    <Box display="flex" justifyContent="center" alignItems="center" p={2}>
      {children}
    </Box>
  );

  return (
    <Box id="discussions-list-wrapper" className={classes.wrapperBox}>
      <InfiniteScroll
        scrollableTarget="discussions-list-wrapper"
        style={{ flexGrow: 1 }}
        dataLength={data?.discussions?.discussions?.length ?? 0}
        scrollThreshold={0.8}
        next={handleNext}
        hasMore={
          (data?.discussions?.discussions?.length ?? 0) <
          (data?.discussions?.totalCount ?? 0)
        }
        loader={<Label>Chargement...</Label>}
        endMessage={<Label>Fin.</Label>}>
        {data?.discussions?.discussions?.map(
          (item) =>
            item && (
              <Link
                key={`message-${item?.id}`}
                style={{ textDecoration: 'none' }}
                to={generatePath('/allDiscussions/:id', { id: item.id })}>
                <DiscussionItem
                  key={`discussion-${item?.id}`}
                  active={item.id === discussionId}
                  discussionName={item?.name ?? ''}
                  discussionAvatarUrl={item?.avatarUrl ?? ''}
                  lastMessage={item.lastMessage}
                  unseenMessageNumber={item.unseenMessageNumber ?? 0}
                />
              </Link>
            ),
        )}
      </InfiniteScroll>
    </Box>
  );
};

export default ListDiscussions;
